<script setup>
import { useRouter, useRoute } from "vue-router";
import { computed } from "vue";

const router = useRouter();
const route = useRoute();

const isHome = computed(() => route.path === "/home");
const isLocations = computed(() => route.path === "/locations");

const redirectToHome = () => {
  router.push("/home");
};

const redirectProperties = () => {
  router.push("/locations");
};

const logOut = () => {
  router.push("/");
};
</script>

<template>
  <v-app-bar
    app
    dark
    image="@/assets/bg/interface.png"
    height="124"
    position="fixed"
  >
    <v-img
      @click="redirectToHome"
      class="cursor-pointer"
      contain
      height="76"
      lazy-src="@/assets/bg/bg-1.png"
      src="@/assets/logo/asic-ins.png"
      max-width="550"
    ></v-img>
    <v-row align="center" class="mr-1">
      <v-col v-if="isLocations" cols="1" class="pl-10">
        <v-img
          src="@/assets/icons/arrow_left.svg"
          contain
          width="45"
          height="45"
          @click="redirectToHome"
          class="cursor-pointer"
        />
      </v-col>
      <v-col class="pl-0 pr-0">
        <v-select
          bg-color="white"
          label="Все"
          variant="solo"
          density="compact"
          rounded="lg"
          class="custom-select"
          menu-icon="mdi-chevron-down"
        >
          <template v-slot:prepend>
            <v-img
              src="@/assets/icons/crane.svg"
              contain
              width="45"
              height="45"
              class="icon-position"
            ></v-img>
          </template>
        </v-select>
      </v-col>
      <v-col class="pl-0 pr-0">
        <v-select
          bg-color="white"
          label="Все"
          variant="solo"
          density="compact"
          rounded="lg"
          class="custom-select"
          menu-icon="mdi-chevron-down"
        >
          <template v-slot:prepend>
            <v-img
              src="@/assets/icons/hat.svg"
              contain
              width="55"
              height="55"
              class="icon-position"
            ></v-img>
          </template>
        </v-select>
      </v-col>
      <v-col md="3" lg="4" class="pl-10 pr-10">
        <v-text-field
          class="search-bar"
          label="Поиск"
          hide-details
          hide-hint
          variant="solo"
          color="primary"
          bg-color="transparent"
          density="compact"
        >
          <template v-slot:append-inner>
            <v-icon color="#00A3FF" size="large">mdi-magnify</v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col v-if="isHome" cols="1">
        <v-img
          src="@/assets/icons/arrow_right.svg"
          contain
          width="45"
          height="45"
          @click="redirectProperties"
          class="cursor-pointer"
        />
      </v-col>
      <v-col cols="2">
        <v-img
          contain
          height="1.5vw"
          width="1.5vw"
          src="@/assets/icons/logout.svg"
          class="img-logout cursor-pointer"
          @click="logOut"
        ></v-img>

        <v-img
          contain
          height="7vw"
          width="9vw"
          src="@/assets/logo/logo-asik.svg"
        ></v-img>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<style scoped>
.img {
  position: absolute;
  top: 2em;
  z-index: 1;
}
.img-logout {
  position: absolute;
  top: 1em;
  right: 1em;
}
.cursor-pointer {
  cursor: pointer;
}
.icon-position {
  left: 2.4em;
  bottom: 0.2em;
  z-index: 10;
}
.search-bar {
  border: 2px solid #00a3ff;
  border-radius: 10px;
}
:deep(.v-input__control),
:deep(.v-input) {
  height: 45px;
}
</style>

<style>
.custom-select .v-input__control {
  border: 2px solid #00a3ff !important;
  border-radius: 10px;
}
.custom-select .v-field-label {
  color: #00507d;
  font-weight: bold;
  padding-left: 10px;
}
</style>
